<app-modal-dialog #modal
    title="{{ (selectedTag.id == '' ? 'reservationTags.tag.create' : 'reservationTags.tag.edit') | translate }}"
    [modalId]="modalId" okText="{{ 'reservationTags.tag.save' | translate }}" [isValid]="isTagValid"
    [errorMessage]="tagErrorMessage" (onClose)="modalClosed($event)">
    <div class="form-col">
        <app-dropdown *ngIf="selectedTag.id == ''" [(model)]="selectedTag.categoryId" [items]="categories"
            [displayProperty]="'name'" [valueProperty]="'id'" (modelChange)="updateValidity()" style="display: block"
            class="mb-2">
        </app-dropdown>

        <input [(ngModel)]="selectedTag.title" (ngModelChange)="updateValidity()" type="text"
            class="ihost-control w-100 mb-2" placeholder="{{ 'reservationTags.placeholders.tag' | translate }}" />

        <input [(ngModel)]="selectedTag.tagOrder" type="number" min="1" step="1" class="ihost-control w-100 mb-2"
            (ngModelChange)="updateValidity()" *ngIf="selectedTag.id != ''"
            placeholder="{{ 'reservationTags.placeholders.tagOrder' | translate }}" />
    </div>
</app-modal-dialog>